import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Particle from "../Particle";
import aboutImg from "../../Assets/about.jpg";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        {/* About BESC Coin Section */}
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col md={7} className="about-description">
            <h1 className="about-heading">
              About <strong className="purple">BESC Coin</strong>
            </h1>
            <Card className="quote-card-view">
              <Card.Body>
                <p className="about-text">
                  BESC Coin is a revolutionary cryptocurrency that seamlessly integrates blockchain technology 
                  with real-world revenue streams. Powered by Builders Edge Services & Construction (BESC LLC), 
                  this innovative token offers a unique profit-sharing model backed by tangible business operations, 
                  providing holders with exceptional value and rewards.
                </p>
                <p className="about-text">
                  Our company has achieved <span className="purple">$310,000 in profits</span> within just five months, 
                  with transparency ensured through verified bank statements and customer checks. BESC Coin is more 
                  than just a token—it's a bridge between traditional business success and cutting-edge blockchain innovation.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={5} className="about-img">
            <img src={aboutImg} alt="about" className="img-fluid" />
          </Col>
        </Row>

        {/* Vision Section */}
        <Row>
          <Col md={12}>
            <h2 className="project-heading">Our <strong className="purple">Vision</strong></h2>
            <Card className="quote-card-view">
              <Card.Body>
                <p style={{ textAlign: "justify" }}>
                  To redefine the construction and home improvement industry by merging real-world profitability 
                  with blockchain technology. BESC Coin creates a transparent ecosystem that rewards investors, 
                  supports sustainable business growth, and fosters innovation across industries.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Key Features Section */}
        <h2 className="project-heading">Key Features of <strong className="purple">BESC Coin</strong></h2>
        <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
          <Col md={6} className="feature-card">
            <Card className="quote-card-view">
              <Card.Body>
                <Card.Title className="purple">1. Real-World Revenue Integration</Card.Title>
                <Card.Text>
                  <ul>
                    <li><strong>Proven Financial Success:</strong> $310,000 in profits within five months, verified by financial records.</li>
                    <li><strong>Reward Pool:</strong> 15% of quarterly or monthly profits dividends to BESC coin holders and NFT holders.</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="feature-card">
            <Card className="quote-card-view">
              <Card.Body>
                <Card.Title className="purple">2. Profit-Sharing System</Card.Title>
                <Card.Text>
                  <ul>
                    <li>Quarterly or Monthly Distributions: Rewards proportional to holdings</li>
                    <li>Blockchain Transparency: Smart contracts automate and secure all distributions</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="feature-card">
            <Card className="quote-card-view">
              <Card.Body>
                <Card.Title className="purple">3. Advanced Staking Rewards</Card.Title>
                <Card.Text>
                  <ul>
                    <li>Share of transaction fees from the Builders Exchange</li>
                    <li>Bonus coins from every ICO listed on the exchange</li>
                    <li>Additional rewards for long-term participants</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="feature-card">
            <Card className="quote-card-view">
              <Card.Body>
                <Card.Title className="purple">4. Client Benefits</Card.Title>
                <Card.Text>
                  <ul>
                    <li>Up to 10% off construction services when paying with BESC Coin</li>
                    <li>Priority scheduling for token holders</li>
                    <li>Exclusive project packages</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Builders Exchange Section */}
        <h2 className="project-heading">The <strong className="purple">Builders Exchange (CEX)</strong></h2>
        <Card className="quote-card-view">
          <Card.Body>
            <p style={{ textAlign: "justify" }}>
              Our cutting-edge cryptocurrency exchange offers:
            </p>
            <ul>
              <li>Futures Trading: Advanced tools for leveraging market trends</li>
              <li>Spot Trading: Secure and user-friendly spot trading</li>
              <li>ICO Launchpad: Support for new projects with bonus coins</li>
              <li>Binary Trading: Intuitive platform for binary options</li>
              <li>Multi-Chain Support: Trade across major blockchain networks</li>
              <li>Merch Store: Purchase exclusive products using BESC Coin</li>
            </ul>
          </Card.Body>
        </Card>

        {/* Company Structure Section */}
        <h2 className="project-heading">Company <strong className="purple">Structure</strong></h2>
        <Card className="quote-card-view">
          <Card.Body>
            <p style={{ textAlign: "justify" }}>
              Builders Edge Services & Construction (BESC LLC) is a trusted leader in the construction 
              industry, delivering high-quality residential and commercial projects. Our team of six 
              full-time professionals brings expertise and dedication to every project, ensuring 
              exceptional results and customer satisfaction.
            </p>
            <p style={{ textAlign: "justify" }}>
              BESC LLC's innovative approach, combining traditional business with blockchain technology, 
              positions BESC Coin as a unique investment opportunity. With a strong foundation, proven 
              profitability, and a growing ecosystem, BESC Coin is shaping the future of construction 
              and finance.
            </p>
          </Card.Body>
        </Card>

        {/* Why Choose BESC Coin Section */}
        <h2 className="project-heading">Why Choose <strong className="purple">BESC Coin?</strong></h2>
        <Card className="quote-card-view">
          <Card.Body>
            <p style={{ textAlign: "justify" }}>
              BESC Coin is more than a cryptocurrency—it's a stake in a thriving, real-world business 
              with a proven track record of success. With profit-sharing, staking rewards, advanced 
              trading features, and exclusive client benefits, BESC Coin offers unparalleled value 
              for investors and customers alike. Join us in building the future of construction and 
              blockchain technology.
            </p>
          </Card.Body>
        </Card>
      </Container>
    </Container>
  );
}

export default About;
